import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";

@Injectable({
  providedIn: "root",
})
export class TermsAndConditionsWS {
  constructor(private handler: BaseHandler) {}
  execute(): Observable<string> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_TERMS_AND_CONDITIONS_ENDPOINT())
      .setMethod(HttpMethod.get)
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => response.url));
  }
}
